export function formatDateForApi(
  date:
    | {
        month: number;
        day: number;
        year: number;
      }
    | string
    | undefined,
) {
  if (!date) {
    return date;
  }

  if (typeof date === "string") {
    if (date.length === 8) {
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);
      return `${year}-${month}-${day}`;
    }
  }

  if (typeof date === "object") {
    const { month, day, year } = date;

    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    return `${year}-${formattedMonth}-${formattedDay}`;
  }
}
